/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PreviewDocumentModal from 'DesignSystem/PreviewDocumentModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Letter/Content",
  onSubmit
  
}) {
let taskResources0DocumentTreeNodeIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'resources[0].document_tree_node.id',
})
let taskResources0MetadataRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'resources[0].metadata.recipient_id',
})
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<PreviewDocumentModal
  viewPath={`${viewPath}/PreviewDocumentModal`}
 data="task.resources[0].document_tree_node.id"
 documentId={taskResources0DocumentTreeNodeIdValueData}
 data="task.resources[0].metadata.recipient_id"
 defaultRecipientId={taskResources0MetadataRecipientIdValueData}
 data="selected"
 onSubmit={selectedSubmitData}
/>
{children}
</React.Fragment>)
}